import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow templates.
 */
export class TemplateOperations {
  constructor(private client: BaserowClient) {}
  
  // Template methods will be implemented here
} 